// Media Assets Constants
// Manually specify each asset's location (local import or CDN URL)

// Local asset imports
import heroImage from '../assets/images/aerialKyustendil.jpg';
import cardImage1 from '../assets/images/tyreInNature.JPG';
import cardImage2 from '../assets/images/exportingBags.JPG';
import aboutUsHeroImage from '../assets/images/hisarluka.jpg';
import getInvolvedHeroImage from '../assets/images/aerialChain.jpg';
import volunteersImage from '../assets/images/vruhRuen.JPG';
import eventsHeroImage from '../assets/images/garbageInNature.jpg';

// Export assets - mix local imports and CDN URLs as needed
export const MEDIA_ASSETS = {
  heroImage: heroImage,
  cardImage1: cardImage1,
  cardImage2: cardImage2,
  aboutUsHeroImage: aboutUsHeroImage,
  getInvolvedHeroImage: getInvolvedHeroImage,
  volunteersImage: volunteersImage,
  eventsHeroImage: eventsHeroImage,
  aboutUsVideo: 'https://videos.ctfassets.net/wdr39pepmha7/5sGA1SzwE83QOuRwvUr0VX/3138420da834a01bddac93b4c582d8f2/aboutus.mp4'
};

// Helper function to get media asset
export const getMediaAsset = (assetName) => {
  return MEDIA_ASSETS[assetName] || null;
}; 